import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
// Import Shared Components
import { Alert } from 'shared-components';
// Import Shared Utils
import formatLocalDateTimeForLocale from '../../utils/formatLocalDateTimeForLocale';
// Import Hooks
import { PIN_UNBLOCK_STATES } from '../../hooks/usePinUnblock';
import useSupportContact from './useSupportContact';

const bold = chunks => <b>{chunks}</b>;

const BANNERS = {
  [PIN_UNBLOCK_STATES.LOCKED]: { for: 'pin-locked', type: 'warn' },
  // The dialog opens over the page; the lock notice stays behind it.
  [PIN_UNBLOCK_STATES.CONFIRMING]: { for: 'pin-locked', type: 'warn' },
  [PIN_UNBLOCK_STATES.UNLOCKED]: { for: 'unlock-pin-success', type: 'success' },
  [PIN_UNBLOCK_STATES.LIMIT_REACHED]: { for: 'unlock-pin-limit', type: 'danger' },
};

// The lock notice for States B-E, shared by the Dashboard and Card Information.
const PinUnblockBanner = ({ state, nextAvailableAt }) => {
  const intl = useIntl();
  const support = useSupportContact();
  const banner = BANNERS[state];

  if (!banner) return null;

  // One span, so the shared Alert's flex layout keeps the space after the bold lead-in.
  return (
    <Alert type={banner.type}>
      <span>
        <FormattedMessage
          id={`${banner.for}-alert`}
          defaultMessage={intl.messages[`${banner.for}-alert`]}
          values={{
            b: bold,
            support,
            time: nextAvailableAt
              ? formatLocalDateTimeForLocale(nextAvailableAt, intl.locale)
              : '',
          }}
        />
      </span>
    </Alert>
  );
};

PinUnblockBanner.propTypes = {
  state: PropTypes.string.isRequired,
  nextAvailableAt: PropTypes.string,
};

PinUnblockBanner.defaultProps = {
  nextAvailableAt: null,
};

export default PinUnblockBanner;
